import { Matrix4x4 } from "../../../../maths/Matrix4x4";
import { Vector3 } from "../../../../maths/Vector3";
export class WebSpotLight {
    setDirection(value) {
        value.cloneTo(this._direction);
    }
    getWorldMatrix(out) {
        var position = this.transform.position;
        var quaterian = this.transform.rotation;
        Matrix4x4.createAffineTransformation(position, quaterian, Vector3.ONE, out);
        return out;
    }
}
